import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { LakeBackfillCountersSchema, LakeStatusSchema } from "@whatslly/types/lake/lake";

export const LakeBackfillProgressSchema = Type.Object({
  ...LakeBackfillCountersSchema.properties,
  startedAt: Type.String(),
  finishedAt: Type.Optional(Type.String()),
});

export const LakeStateSchema = Type.Object({
  status: LakeStatusSchema,
  backfillProgress: Type.Optional(LakeBackfillProgressSchema),
  lastSyncAt: Type.Optional(Type.String()),
  error: Type.Optional(Type.String()),
});
export type LakeState = TypeBoxToType<typeof LakeStateSchema>;
